import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { T2Code } from '@lockton-apps/shared/interfaces';
import { AuthApiActions } from '@lockton-apps/shared/action/auth';
import { T2CodeApiActions } from '@lockton-apps/shared/action/t2-codes';
import { AuthActions } from '@lockton-apps/shared/data-access/auth';

export const T2_CODES_FEATURE_KEY = 't2Codes';

export interface T2CodesState extends EntityState<T2Code> {
  selectedId?: string | number; // which T2Codes record has been selected
  loaded: boolean; // has the T2Codes list been loaded
  error?: string | null; // last known error (if any)
}

export interface T2CodesPartialState {
  readonly [T2_CODES_FEATURE_KEY]: T2CodesState;
}

export const t2CodesAdapter: EntityAdapter<T2Code> =
  createEntityAdapter<T2Code>();

export const initialT2CodesState: T2CodesState = t2CodesAdapter.getInitialState(
  {
    loaded: false,
  }
);

const reducer = createReducer(
  initialT2CodesState,
  on(AuthActions.initSuccess, AuthApiActions.loginSuccess, (state) => ({
    ...state,
    error: null,
  })),
  on(T2CodeApiActions.loadAllSuccess, (state, { t2Codes }) =>
    t2CodesAdapter.setAll(t2Codes, {
      ...state,
      loaded: true,
    })
  ),
  on(T2CodeApiActions.loadAllFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function t2CodesReducer(
  state: T2CodesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
